import angular from 'angular';
const dependencies = window.importAngularDependencies(require.context('./', true, /\.ts/), './video-chat.common.js');
export default angular.module('doxy.videoChat.userMediaStatus.common', dependencies).name;
